import { Injectable } from '@angular/core';
import dayjs from './dayjs-config';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  private lang = 'en';

  get() {
    return this.lang
  }

  set(lang: string) {
    this.lang = lang
    dayjs.locale(lang)
  }
}
